export const hackathonName = "MakeUofT 2027";
export const adminGroup = "Hardware Site Admins";
export const minTeamSize = 2;
export const maxTeamSize = 4;
export const hardwareSignOutStartDate = new Date(2026, 1, 8, 23, 59);
export const hardwareSignOutEndDate = new Date(2026, 1, 15, 9, 0);
export const hssTestUserGroup = "HSS Test Users";
export const serverUrl = "https://makeuoft.ca";
export const minProjectDescriptionLength = 60;
export const startingCredits = 300;
